import { render } from "./ImagePlaceholder.vue?vue&type=template&id=4ea17906&scoped=true"
import script from "./ImagePlaceholder.vue?vue&type=script&lang=js"
export * from "./ImagePlaceholder.vue?vue&type=script&lang=js"

import "./ImagePlaceholder.vue?vue&type=style&index=0&id=4ea17906&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea17906"]])

export default __exports__